// extracted by mini-css-extract-plugin
export default {"contentWrapper":"AttributeSidebar_contentWrapper__1E6mk"};